import { FunctionComponent } from "react";
import AsyncSearchSelect from "../common/async_search_select/AsyncSearchSelect";
import { fetchGet, toQueryString } from "../../../service/api_client";
import { Project } from "../../../erp/inventory/models/project_model";

interface ProjectSelectFieldProps {
  value?: Project | null;
  onSelect: (project: Project) => void;
  disabled?: boolean;
  placeholder?: string;
}

const fetchProjects = async (query: string): Promise<Project[]> => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/project/`;
  const res = await fetchGet(
    url + toQueryString({ search: query, page: 1, count: 20, all: true }),
  );
  if (!res.success || !Array.isArray(res.data?.data)) return [];
  return res.data.data.filter((p: Project) => p.projectStatus === "Open");
};

/** Open-project async search. Reusable wherever a project picker is needed. */
const ProjectSelectField: FunctionComponent<ProjectSelectFieldProps> = ({
  value,
  onSelect,
  disabled,
  placeholder,
}) => (
  <AsyncSearchSelect<Project>
    value={value ?? null}
    onSelect={onSelect}
    disabled={disabled}
    size="md"
    placeholder={placeholder ?? "Search project"}
    fetcher={fetchProjects}
    getOptionLabel={(p) => p?.name ?? ""}
    getOptionKey={(p) => p?.id ?? ""}
    renderOption={(p) => (
      <div className="text-xs">
        <b>{p.name}</b>
      </div>
    )}
  />
);

export default ProjectSelectField;
